var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9814 1.16668L4.02464 12.0385C3.07473 12.4315 0.975989 13.133 0.429323 13.7522C-0.00599251 14.2453 -0.148695 14.993 0.181395 15.6876C0.48698 16.3308 0.91689 16.5262 1.78464 16.7485C3.21599 17.1153 4.58644 17.4639 6.01707 17.8157C9.97815 18.789 10.4344 18.8996 13.9782 16.4174C16.5767 14.5975 20.789 11.9385 23.5991 10.1036C24.1418 9.74917 24.6354 9.40533 25.1908 9.04257C25.59 8.78169 26.4373 8.0318 26.8996 8.28904C27.4088 8.69874 26.7551 9.06586 26.3947 9.47738L20.4549 15.1636C19.8318 15.8342 17.367 17.9292 16.5904 18.8294C16.3317 19.1292 14.8131 20.319 16.1461 21.714C18.0542 23.7115 25.0387 28.3455 27.5396 30.2419C29.5958 31.801 31.4228 30.7313 31.9263 29.3083C32.2333 28.4405 32.4239 26.4299 32.5807 25.4184C33.0938 22.1088 33.8019 16.3399 34.3929 13.6213C34.5987 11.5419 35.0452 9.18411 35.3749 7.08797C35.5428 6.02226 35.6963 4.97473 35.8628 3.89446C36.0657 2.5766 36.1345 2.05047 35.4531 1.03279C34.7796 0.425521 34.1284 -0.277073 32.6596 0.111882C31.7673 0.348021 30.8718 0.914171 29.9814 1.16668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.fb645db7905372919595aea93fc9f050.svg";
export { ForwardRef as ReactComponent };